import { withInstall } from '@zoryn/utils'
import Watermark from './src/watermark.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZWatermark: SFCWithInstall<typeof Watermark> =
  withInstall(Watermark)
export default ZWatermark

export * from './src/watermark'
